define('root/Assets/Js/HoverHandler',[
	'jquery',
	'project/MbiConfig',
	'base/MbiMediaQuery',
], function(
	$,
	mbiConfig,
	mbiMq
) {
	'use strict';

	// ---------------------------------------------------------------
	// HOVER-ON-MOUSE/TAP-ON-TOUCH HANDLER
	// ---------------------------------------------------------------

	if(Modernizr.touch || $('html').hasClass('ios')) {

		$(document).on('click', '.js_hover', function() {

			if(!$(this).hasClass('is_locked')) {

				if(!$(this).hasClass('is_active')) {

					$('.js_hover, .js_hover .js_hover-depend').removeClass('is_active');
					$(this).addClass('is_active');

					if($(this).hasClass('product') && ('paw-' in mbiMq.mqArea)) {
						var onep = $(this).parent().width() / 100;
						var posle = $(this).position().left / onep;
						if(posle < 50) {
							$(this).removeClass('position-left').addClass('position-right');
							// if(posle < 0) {
							// 	posle = posle * -1;
							// }
							// $(this).css('left', 'calc('+posle+'% - 100px');
						} else {
							$(this).removeClass('position-right').addClass('position-left');
						}
					}
					$(this).find('.js_hover-depend').addClass('is_active');

				}

			}

		});

		//close hover state by click on close toch icon
		$(document).on('click', '.is_active .touch--hover', function (e) {
			e.stopPropagation();
			console.log($(this));
			if ($(this).parent().hasClass('is_active')) {
				$(this).parent().removeClass('is_active');
			}
		});

		$(document).on('click', '.social--share.is_active', function(){

				$(this).removeClass('is_active');

		});

	} else {

		$('.js_hover').attr('tabindex', '0');

		$(document).on('mouseenter focus', '.js_hover', function() {

			if(!$(this).hasClass('is_locked')) {
				$(this).addClass('is_active');

				if($(this).hasClass('product') && ('paw-' in mbiMq.mqArea)) {
					var onep = $(this).parent().width() / 100;
					var posle = $(this).position().left / onep;
					if(posle < 50) {
						$(this).removeClass('position-left').addClass('position-right');
						// if(posle < 0) {
						// 	posle = posle * -1;
						// }
						// $(this).css('left', 'calc('+posle+'% - 100px');
					} else {
						$(this).removeClass('position-right').addClass('position-left');
					}
				}
				$(this).find('.js_hover-depend').addClass('is_active');

			}

		});
		$(document).on('mouseleave blur', '.js_hover', function() {

			if(!$(this).hasClass('is_locked')) {

				$(this).removeClass('is_active');
				$(this).find('.js_hover-depend').removeClass('is_active');

			}

		});

	}

	mbiConfig.modules.HoverHandler = true;

});
